import { TextAreaEditDropdown } from "./TextAreaEditDropdown";
import { useToast } from "hooks/useToast";
import { useCallback } from "react";
import { useUpdateTaskAssigneeAdminMutation } from "store/apis/serviceTeam";
import { Task1120Tracker } from "types/Models/TaskTracker";

export const MissingInformationColumn = ({ row }: { row: Task1120Tracker }) => {
  const [updateTaskAssignee, { isLoading }] =
    useUpdateTaskAssigneeAdminMutation();
  const { alertToast, successToast } = useToast();
  const inputValue = row.missing_information ?? "";

  const handleSave = useCallback(
    async (value: string) => {
      try {
        await updateTaskAssignee({
          taskId: row.task_uuid,
          missing_information: value || null,
        }).unwrap();
        successToast({ message: "Missing information updated" });
      } catch (error: any) {
        alertToast({ message: error?.data?.error?.message });
      }
    },
    [row.task_uuid, updateTaskAssignee, successToast, alertToast]
  );

  return (
    <TextAreaEditDropdown
      title="Missing Information"
      fieldName="missing_information"
      initialValue={inputValue}
      placeholder="Add missing information..."
      isLoading={isLoading}
      onSave={handleSave}
    />
  );
};
